// extracted by mini-css-extract-plugin
export default {"info-txt":"info-txt","feedback-img-holder":"feedback-img-holder"};